class ImagesEventSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.switchImages = document.querySelectorAll(
      ".event-section__main-image-item"
    );
    this.switchButtons = document.querySelectorAll(
      ".event-section__image-item-button"
    );
    
    this.switchButtons.forEach((item, index) => {
      item.addEventListener("click", () => this.switchAction(index));
    });
  }

  switchAction(index) {
    // Виправляємо логіку переключення
    this.switchButtons.forEach((button, idx) => {
      if (index === idx) {
        button.classList.add("event-section__image-item-button--selected");
      } else {
        button.classList.remove("event-section__image-item-button--selected");
      }
    });

    this.switchImages.forEach((image, idx) => {
      if (index === idx) {
        image.classList.add("event-section__main-image-item--selected");
      } else {
        image.classList.remove("event-section__main-image-item--selected");
      }
    });
  }
}

customElements.define("images-event-slider", ImagesEventSlider);
